export const LEVEL_MIN_ZOOM = 16;
